import { React, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
import MainUpdateAdmini from './MainUpdateAdmini'
import UpdateAdminiCreate from './UpdateAdminiCreate';
import UpdateAdminiUpdate from './UpdateAdminiUpdate';

/*!!You must import boostrap 
npm install react-bootstrap bootstrap <--*/
function UpdateAdminiApp() {


    return (
        <div>
                <Routes>
                    <Route path='/' element={<MainUpdateAdmini />}></Route>
                    <Route path='/createAdmini' element={<UpdateAdminiCreate />}></Route>
                    <Route path='/updateAdmini/:id' element={<UpdateAdminiUpdate />} />
                </Routes>
        </div>
    )
}
export default UpdateAdminiApp;
